export enum TransactionReferenceIdType {
  RBIOrderId = 'RBIOrderId',
}
